import { useCallback, useState } from 'react';
import { useLocation } from '@tanstack/react-router';

type DownloadButtonVisibilityState = {
  locationKey: string;
  reportId: string;
  visibilityByReportId: Record<string, boolean>;
};

export const useHandleDownloadButtonVisibility = (reportId: string) => {
  const location = useLocation();
  const locationKey = `${location.pathname}?${location.searchStr}`;
  const [state, setState] = useState<DownloadButtonVisibilityState>(() => ({
    locationKey,
    reportId,
    visibilityByReportId: reportId ? { [reportId]: true } : {},
  }));

  let currentState = state;
  if (state.locationKey !== locationKey) {
    const visibilityByReportId = { ...state.visibilityByReportId };
    if (state.reportId) visibilityByReportId[state.reportId] = false;
    if (reportId && visibilityByReportId[reportId] === undefined) {
      visibilityByReportId[reportId] = true;
    }

    currentState = { locationKey, reportId, visibilityByReportId };
    setState(currentState);
  }

  const changeDowloadButtonVisibility = useCallback((id: string, value: boolean) => {
    setState((previousState) => ({
      ...previousState,
      visibilityByReportId: {
        ...previousState.visibilityByReportId,
        [id]: value,
      },
    }));
  }, []);

  return {
    isDownloadButtonVisible: currentState.visibilityByReportId[reportId],
    changeDowloadButtonVisibility,
  };
};
